import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';

import Button from 'components/CustomButtons/Button.jsx';
import Card from 'components/Card/Card.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import InputBox from 'components/InputBox';
import providerGenres from 'config/providerSeedGenres';

export const BrowseByGenre = () => {
  const [list, setList] = useState(providerGenres);
  const [searchOn, setSearchOn] = useState(false);

  const onInput = (value) => {
    const pattern = new RegExp(value);
    const items = providerGenres.filter((e) => pattern.test(e));
    setList(items);
  };

  return (
    <Card>
      <GridContainer
        style={{
          backgroundColor: '#FFFFFF',
          margin: '-30px 0px 0px 0px',
        }}
      >
        {searchOn ? (
          <GridItem xs={12} md={12}>
            <div style={{ marginTop: '20px', width: '90%' }}>
              <InputBox onInput={onInput} />
            </div>
          </GridItem>
        ) : (
          <GridContainer>
            <GridItem xs={8} md={8}>
              <h4
                style={{
                  fontWeight: '600',
                  color: '#171055',
                  textAlign: 'left',
                  padding: '20px 0px 10px 40px',
                  fontSize: '24px',
                }}
              >
                Browse By Genre
              </h4>
            </GridItem>
            <GridItem xs={4} md={4}>
              <div style={{ color: '#171055', margin: '30px 0 0 20px' }}>
                <SearchIcon
                  fontSize="large"
                  onClick={() => setSearchOn(true)}
                />
              </div>
            </GridItem>
          </GridContainer>
        )}
      </GridContainer>

      {/* Buttons groups */}
      <div
        style={{
          backgroundColor: 'white',
          padding: '20px 0px 100px 0px',
        }}
      >
        <GridContainer
          style={{
            backgroundColor: '#FFFFFF',
            margin: '-20px 0px 0px -24px',
            padding: '12px 0px 0px 50px',
          }}
        >
          {list.map((e) => (
            <div key={e} style={{ margin: '6px 2px' }}>
              <Link to={`/swipe/collection/${e}`}>
                <Button
                  style={{
                    width: '75%',
                    borderRadius: '50px',
                    backgroundColor: '#F4F4F4',
                    border: '2px solid #E1E1E1',
                  }}
                >
                  <b style={{ color: '#171055' }}>{e}</b>
                </Button>
              </Link>
            </div>
          ))}
        </GridContainer>
      </div>
    </Card>
  );
};

export default BrowseByGenre;
